import customerInstance from '../instance'

const updateDeliveryPeriods = (id, data) => {
  return customerInstance.put('/deliveryPeriods/' + id, data)
}

export default updateDeliveryPeriods
